export const PurchasesCardConstants = {
  TryAgainButton: 'Try again',
  GetHelpButton: 'Get help',
  ManageSubscriptionButton: 'Manage subscription',
  ManagePaymentButton: 'Manage payment',
  ArrowDownIconText: 'Arrow down icon',
  SingularMoreProductsLabel: 'more product',
  PluralMoreProductsLabel: 'more products',
  FinalCardText: `Not found what you're looking for?`,
} as const

// §356a BGB prescribes the German labels: 'Vertrag widerrufen' to withdraw, 'Widerruf bestätigen'
// to confirm. Do not reword either without Legal.
// Billing names the buyer's email in the modal body; /support/orders returns none, so ours stops at
// 'by email'. German `SuccessBody` and `ErrorMessage` are still awaiting translation review.
export const WithdrawalConstants = {
  en: {
    Cta: 'Request withdrawal',
    // Billing names the subscription here. The nearest thing an order has is its primary product,
    // which is what the card headlines; the generic title covers an order that carries none.
    ModalTitle: (productName?: string) => (productName ? `Withdraw from ${productName}?` : 'Withdraw this purchase?'),
    // Split into three parts so the middle clause can carry the emphasis the mockups ask for.
    ModalBody: {
      before: `You'll `,
      emphasis: 'lose access immediately',
      after: ' and receive a confirmation by email.',
    },
    ConfirmButton: {
      subscription: 'Withdraw from subscription',
      oneOff: 'Withdraw from purchase',
    },
    ErrorMessage: `We couldn't submit your withdrawal. Please try again.`,
    SuccessTitle: 'Withdrawal requested',
    SuccessBody: `We've received your withdrawal. A confirmation is on its way to your email.`,
    // Not 'Close': Ant already uses that name for the dialog's own close control.
    DismissButton: 'Done',
  },
  de: {
    Cta: 'Vertrag widerrufen',
    // The reviewed German title names no product, so the argument goes unused.
    ModalTitle: (_productName?: string) => 'Diesen Kauf widerrufen?',
    ModalBody: {
      before: 'Sie ',
      emphasis: 'verlieren sofort den Zugriff',
      after: ' und erhalten eine Bestätigung per E-Mail.',
    },
    // §356a BGB prescribes the one label, whatever the purchase is.
    ConfirmButton: {
      subscription: 'Widerruf bestätigen',
      oneOff: 'Widerruf bestätigen',
    },
    ErrorMessage: 'Ihr Widerruf konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.',
    SuccessTitle: 'Widerruf beantragt',
    SuccessBody: 'Wir haben Ihren Widerruf erhalten. Eine Bestätigung wird an Ihre E-Mail-Adresse gesendet.',
    DismissButton: 'Fertig',
  },
} as const

export const PurchasesPageConstants = {
  PageTitleSingleProduct: 'Is this the product or subscription you want help with?',
  PageTitleMultipleProducts: 'Which product or subscription do you want help with?',
} as const
